<template lang="pug">
.icon-pending
  svg(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100")
    circle(cx="50" cy="50" :r="50" fill="#00B578")
    path(d="M50 50 v-25z" :transform="`rotate(${d1 % 360}, 50, 50)`")
    path(d="M50 50 l18 18z" :transform="`rotate(${d2 % 360}, 50, 50)`")
    //path(d="M18.98 25.79l-5.35-5.35-2.14 2.14 7.49 7.49 2.14-2.14L33.23 15.8l-2.14-2.14-12.12 12.12z" fill="#ffffff" fill-rule="nonzero")

  
</template>
<script>
import gsap from 'gsap'
export default {
  name: 'IconPending',
  props: {},
  data() {
    return {
      t1: 0,
      t2: 0,
      t3: 0,
      d1: 0,
      d2: 0,
    }
  },
  computed: {},
  methods: {
    animeIn() {
      gsap
        .timeline()
        .to(this, { t1: 1, duration: 0.2, ease: 'power3.out' })
        .to(this, { t2: 1, duration: 0.2, ease: 'power3.out' }, 0.1)
        .to(this, { t3: 1, duration: 0.2, ease: 'power3.out' }, 0.2)
    },
    animeOut() {
      gsap.to(this, { t1: 0, t2: 0, t3: 0, duration: 0.2, ease: 'power3.out' })
    },
    animation() {
      this.d1 += 0.8
      this.d2 += 8
    },
  },
  mounted() {
    gsap.ticker.add(this.animation)
  },
  destroy() {
    gsap.ticker.remove(this.animation)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.icon-pending
  line-height: 0
  width: 100%
  height: 100%
  svg
    width: 100%
    height: 100%
    path
      stroke-linejoin: round
      stroke-linecap: round
      stroke: #ffffff
      stroke-width: 8
</style>
